// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../css-loader/dist/cjs.js!../../stripes-components/lib/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-editor {
  min-height: 100px !important;
  resize: vertical;
}

.ql-token {
  font-weight: 500;
  padding-bottom: 5px;
}

.ql-toolbar {
  border-bottom: none !important;
}

.ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
  content: 'Small';
}
.ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
  font-size: var(--font-size-x-small);
}

.ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: 'Large';
}
.ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  font-size: var(--font-size-large);
}

.ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
.ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: 'Huge';
}
.ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  font-size: var(--font-size-xx-large);
}

.ql-editor li::before {
  text-indent: 0;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@folio/stripes-template-editor/src/quillCustom.css"],"names":[],"mappings":"AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB","sourcesContent":["@import \"~@folio/stripes-components/lib/variables.css\";\n\n.ql-editor {\n  min-height: 100px !important;\n  resize: vertical;\n}\n\n.ql-token {\n  font-weight: 500;\n  padding-bottom: 5px;\n}\n\n.ql-toolbar {\n  border-bottom: none !important;\n}\n\n.ql-picker.ql-size .ql-picker-label[data-value=\"10px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"10px\"]::before {\n  content: 'Small';\n}\n.ql-picker.ql-size .ql-picker-item[data-value=\"10px\"]::before {\n  font-size: var(--font-size-x-small);\n}\n\n.ql-picker.ql-size .ql-picker-label[data-value=\"18px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"18px\"]::before {\n  content: 'Large';\n}\n.ql-picker.ql-size .ql-picker-item[data-value=\"18px\"]::before {\n  font-size: var(--font-size-large);\n}\n\n.ql-picker.ql-size .ql-picker-label[data-value=\"32px\"]::before,\n.ql-picker.ql-size .ql-picker-item[data-value=\"32px\"]::before {\n  content: 'Huge';\n}\n.ql-picker.ql-size .ql-picker-item[data-value=\"32px\"]::before {\n  font-size: var(--font-size-xx-large);\n}\n\n.ql-editor li::before {\n  text-indent: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
